(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["heading-swiper-navigation"] && !Shopify.designMode) return;
  try {
    class CustomSwiperButtons extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    this.querySelectorAll("[data-slider-id]").forEach((button) => this.bindButton(button));
  }

  bindButton(button) {
    const slider = document.getElementById(button.dataset.sliderId);
    if (!slider) return;

    const selector = slider.getAttribute(
      button.classList.contains("swiper-button-prev")
        ? "navigation-prev-el"
        : "navigation-next-el"
    );

    const realButton = document.querySelector(selector);
    if (!realButton) return;

    const syncState = () => {
      const isDisabled = realButton.classList.contains("swiper-button-disabled");
      const isLocked = realButton.classList.contains("swiper-button-lock");

      button.classList.toggle("swiper-button-disabled", isDisabled);
      button.classList.toggle("swiper-button-lock", isLocked);

      button.disabled = realButton.disabled || isLocked;
    };

    syncState();

    new MutationObserver(syncState).observe(realButton, {
      attributes: true,
      attributeFilter: ["class", "disabled"],
    });
  }
}

customElements.define('custom-swiper-buttons', CustomSwiperButtons);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["image-accordion"] && !Shopify.designMode) return;
  try {
    class DuskImageAccordion extends HTMLElement {
    connectedCallback() {
        this.changeImage = this.dataset.changeImage === 'true';
        this.closeOthersOnOpen = this.dataset.closeOthersOnOpen !== 'false';
        if (this.changeImage) this.closeOthersOnOpen = true;
        this.items = Array.from(this.querySelectorAll('.image-accordion__item'));

        for (const item of this.items) {
            const header = item.querySelector('.image-accordion__header');
            header?.addEventListener('click', () => this.toggle(item));
        }

        if (this.changeImage) {
            const openItem = this.items.find((item) => item.classList.contains('is-open'));
            if (openItem) this.swapImage(openItem);
        }
    }

    toggle(item) {
        const isOpen = item.classList.contains('is-open');

        if (isOpen) {
            // Keep one item open when it is linked to the section image.
            // if (this.changeImage) return;
            this.setOpen(item, false);
            return;
        }

        for (const other of this.items) {
            if (other !== item && this.closeOthersOnOpen) this.setOpen(other, false);
        }

        this.setOpen(item, true);
        if (this.changeImage) this.swapImage(item);
    }

    setOpen(item, open) {
        item.classList.toggle('is-open', open);
        item.querySelector('.image-accordion__header')?.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    swapImage(item) {
        if (!item.dataset.image) return;

        const wrapper = this.closest('.section-content-columns') || this.closest('section');
        const picture = wrapper?.querySelector('dusk-picture');
        if (!picture) return;

        picture.dispatchEvent(new CustomEvent('reload-picture', {
            detail: {
                image: item.dataset.image,
                imageMobile: item.dataset.imageMobile || '',
            },
        }));
    }
}

customElements.define('dusk-image-accordion', DuskImageAccordion);
  } catch(e) { console.error(e); }
})();

})();
